/**
 * Created by
 */

var config = require("./config.js")
var window = require("../../../support/window.js")
var sessionStorage = window.sessionStorage;

var cacheKeyBase = "TELLHOWDM_FDAPI_CACHE_"

/**
 * 请求辅助方法
 *
 * @param urlConfigGroup URL配置的分组
 * @param urlConfigName URL配置的名称
 * @param parmars 请求参数
 * @param enforceReload 如果为true，强制重新加载
 * @param funcCheckDataValid 检查数据有效性，返回true，表示数据有效，进行缓存
 * @returns {*} 标准的Promise对象，通过then/cache方法获取回调结果
 */
var reqHelper = function(urlConfigGroup, urlConfigName, parmars, enforceReload, funcCheckDataValid) {
    // 缓存key
    var cacheKey = cacheKeyBase + "_" + urlConfigGroup + "_" + urlConfigName + "_" + JSON.stringify(parmars);
    // 检查缓存
    var cache = sessionStorage.getItem(cacheKey);
    if (enforceReload != true && cache) {
        return new Promise(function(resolve) {
            resolve(JSON.parse(cache));
        });
    }
    // 发出请求
    return config.getConfigUrl(
        urlConfigGroup, urlConfigName

    ).then(function (url) {
        // 增加参数
        for (var k in parmars) {
            url = url + (url.indexOf("?") < 0 ? "?" : "&") + k + "=" + parmars[k];
        }
        // 发出请求
        return window.fetch(url)

    }).then(function (response) {
        return response.json()

    }).then(function(json) {
        // 缓存数据
        if (funcCheckDataValid && typeof(funcCheckDataValid) == 'function' && funcCheckDataValid(json)) {
            sessionStorage.setItem(cacheKey, JSON.stringify(json));
        }
        // 继续返回
        return json;

    })
};

module.exports = {
    reqHelper : reqHelper
}



//////////////////
// WEBPACK FOOTER
// ./src/main/javascript/func/fdapi/commons/helper.js
// module id = 16
// module chunks = 0